import React, { createContext, useState, useContext } from 'react';

export const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [isMenuOpen, setIsMenuOpen] = useState(() => {
    try {
      return localStorage.getItem('vance_menu_open') === 'true';
    } catch {
      return false;
    }
  });

  function toggleMenu() {
    setIsMenuOpen((prev) => {
      const next = !prev;
      localStorage.setItem('vance_menu_open', String(next));
      return next;
    });
  }

  function setMenuOpen(value) {
    setIsMenuOpen(value);
    localStorage.setItem('vance_menu_open', String(value));
  }

  return (
    <UIContext.Provider value={{ isMenuOpen, toggleMenu, setMenuOpen }}>
      {children}
    </UIContext.Provider>
  );
}

export const useUI = () => useContext(UIContext);
